export class ControlOptionDto {
    id!: string;
    ngxFormlyFormId!: string;
    valueConfPageId!: string;
    label!: string;
    value!: string;
}